
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/cases/[slug]",
      function () {
        return require("private-next-pages/[locale]/cases/[slug].page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/cases/[slug]"])
      });
    }
  